<template>
  <Admin style="background: #f2f2f2;">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80" id="setting-key">
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <div class="alert" v-if="alert">
              <span class="mx-3">
                หนังสือรับรองของคุณใกล้หมดอายุ
                <u class="ml-2"><b>สมัครรับ Token ใหม่</b></u>
              </span>
              <v-icon color="#fff" class="mx-2" @click="alert = false">mdi-close-circle-outline</v-icon>
            </div>
            <div class="tw-mx-5 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">รายละเอียดหนังสือรับรอง</div>
            <v-row style="overflow-x: auto;" class="tw-mx-5 tw-mt-2">
              <v-col>
                <v-row v-for="key in listKey" :key="key.id" class="cer-row mb-3">
                  <v-col class="col-detail">
                    <div class="header">หนังสือรับรองปัจจุบัน</div>
                    <div>{{ key.serialNumber }}</div>
                  </v-col>
                  <v-col class="col-detail">
                    <div class="header">ชื่อผู้ออก</div>
                    <div class="data-detail">{{ getNameIssuer(key.nameIssuer) }}</div>
                  </v-col>
                  <v-col class="col-detail">
                    <div class="header">ชื่อบริษัท</div>
                    <div class="data-detail">{{ getNameSubject(key.nameSubject) }}</div>
                  </v-col>
                  <v-col class="col-detail">
                    <div class="header">วันที่ / เวลาเริ่มต้น</div>
                    <div class="data-detail">{{ timeFormat(key.timeNotBefore) }}</div>
                  </v-col>
                  <v-col class="col-detail">
                    <div class="header">วันที่ / เวลาหมดอายุ</div>
                    <div class="text-blue data-detail"><b>{{ timeFormat(key.timeNotAfter) }}</b></div>
                  </v-col>
                  <v-col class="col-status-detail">
                    <div class="header">สถานะ</div>
                    <b class="color-green data-detail" v-if="checkExpireDate(key.timeNotAfter)">ยังไม่หมดอายุ</b>
                    <b class="color-red data-detail" v-else>หมดอายุ</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <div v-else class="align-center justify-center" style="height: 200px; display: flex;">
            No Permission
          </div>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>
<script>
import Admin from '../../components/admin/admin-main-template'
import {mapState} from "vuex";
import moment from 'moment';
import 'moment/locale/th';

moment.locale('th')

export default {
  name: 'Board',
  components: {
    Admin
  },
  computed: mapState({
    listKey: state => state.keyByCompany.listKey,
    selectedCompany: state => state.companies.selectedCompany,
  }),
  created() {
    this.query()
  },
  data: () => ({
    items: [
      {
        text: 'ตั้งค่า',
        disabled: false,
        to: {name: 'Company.Settings'},
      },
      {
        text: 'หนังสือรับรอง',
        disabled: true,
      },
    ],
    dialog: false,
    alert: false,
  }),
  watch: {
    listKey: {
      handler: function () {
        this.alertToken();
      }
    },
  },
  beforeDestroy() {
    this.$store.dispatch('keyByCompany/getCerListUnsubscribe')
  },
  methods: {
    query: function () {
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch('keyByCompany/getList', {companyId})
      }
    },
    checkExpireDate: function (endDate) {
      let date = moment.unix(endDate.seconds)
      if (date.toDate()) {
        return date.toDate() > new Date()
      }
    },
    deleteKey: function (KeyId) {
      this.dialog = false
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch('keyByCompany/deleteKey', {companyId, KeyId})
      }
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate()).add(543, 'years').format('Do MMM YY, LTS')
      }
      return "-"
    },
    getNameIssuer: function (nameIssuer) {
      let name = "-"
      if (nameIssuer && nameIssuer.CN) {
        name = nameIssuer.CN
      }
      if (nameIssuer && nameIssuer.O) {
        name = `${name} (${nameIssuer.O})`
      }
      return name
    },
    getNameSubject: function (nameSubject) {
      let name = "-"
      if (nameSubject && nameSubject.CN) {
        name = nameSubject.CN
      }
      if (nameSubject && nameSubject["2.5.4.97"]) {
        name = `${name} (${nameSubject["2.5.4.97"]})`
      }
      return name
    },
    alertToken: function () {
      let isExpire = this.listKey.find((key) => moment.unix(key.timeNotAfter.seconds).diff(new Date(), 'days') <= 30)
      if (isExpire) {
        this.alert = true
      }
    },
  }
}
</script>

<style lang="scss">
#setting-key {
  .flex-container {
    display: flex;
    flex-flow: row nowrap;
    min-height: 114px;
    border-radius: 20px;
    border: solid 1px #707070;
    font-size: 16px;

    div {
      .header {
        margin-bottom: 15px;
      }
    }
  }

  .color-green {
    color: #6ec39b;
  }

  .color-red {
    color: #c9242b;
  }

  .row {
    color: #191919 !important;
  }

  .v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 10px !important;
    border-color: #c4c4c4;;
  }

  .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: unset;
  }

  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 50px;
  }

  .v-input__slot {
    margin-bottom: unset;
  }

  .data-detail {
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 300px;
    white-space: nowrap;
  }

  .col-detail {
    width: 200px;
    margin: auto;
  }

  .col-status-detail {
    width: 100px;
    margin: auto;
  }

  .cer-row {
    border-radius: 20px;
    border: solid 1px #707070;
    min-height: 100px;
  }

  .text-blue {
    color: #619fd4;
  }

  .alert {
    width: 434px;
    height: 66px;
    background-color: #c9242b;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 24px;
    color: #ffffff;
    display: flex;
    align-items: center;
    font-size: 16px;

    @media only screen and (max-width: 700px) {
      width: 100%;
      height: 44px;
      position: relative;
      border-radius: 10px;
    }

  }
}
</style>
